import BackendAPIService from './BackendAPIService'

class LoyaltyPointsService extends BackendAPIService {
  constructor(params) {
    super({ apiVersion: 'v1', ...params })
  }

  getWelcomeBonusBasePath() {
    return `/loyalty-points-service/${this.apiVersion}/${this.tenantPath}/points/bonus?type=welcome_bonus`
  }

  async getRedPointsWelcomeBonus() {
    const response = await this.get(this.getWelcomeBonusBasePath())
    this.logger.debug(`get RedPoints welcome bonus`, 'dataFetching')
    return response.data
  }
}

export default LoyaltyPointsService
